import { Checkbox, useTheme } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

interface Props extends GridRenderCellParams {
  checked: boolean
  onChange: (id: string, value: boolean) => void
}
export const CheckboxCell = ({ checked, onChange, ...props }: Props) => {
  const theme = useTheme()

  return (
    <Checkbox
      checked={checked}
      color={theme.palette.mode === 'dark' ? 'primary' : 'default'}
      onClick={(event) => {
        onChange(props.id.toString(), !checked)
        event.preventDefault()
        event.stopPropagation()
      }}
    />
  )
}
